export const PROMOTION_POPPER = 'promotion-popper';
export const FETCH_PROMOTION_ASSETS = 'FETCH_PROMOTION_ASSETS';
export const FETCH_PROMOTION_ASSETS_SUCCESS = 'FETCH_PROMOTION_ASSETS_SUCCESS';
export const FETCH_PROMOTION_ASSETS_FAILURE = 'FETCH_PROMOTION_ASSETS_FAILURE';
export const PROMOTION_DETAILS_KEY = 'PROMOTION_DETAILS_KEY';
export const bottleCount = 3;
export const equipmentIndicator = 1;
export const SET_PROMOTION_DETAILS = 'SET_PROMOTION_DETAILS';
